import ProductLessorView from './ProductLessorView'

export default ProductLessorView
